module.exports = __webpack_public_path__ + "img/record-active.1ce1516e.svg";